<script setup lang="ts">
export interface BaseTabProps {
  heading?: string;
  disabled?: boolean;
  hidden?: boolean;
  icon?: { name: string; path?: string };
}

const props = defineProps<BaseTabProps>();
</script>

<template>
  <slot :props="props" />
</template>
